import type { en } from './en';
import { trClarity } from './tr-clarity';
import { trSector } from './tr-sector';
import { trWeapons } from './tr-weapons';
import { trWorld } from './tr-world';
import { trShop } from './tr-shop';
import { trMaps } from './tr-maps';
import { trHangar } from './tr-hangar';
import { trPolish } from './tr-polish';

/** Turkish strings. */
export const tr: Record<keyof typeof en, string> = {
  ...trClarity,
  ...trWeapons,
  ...trWorld,
  ...trShop,
  ...trMaps,
  ...trHangar,
  ...trSector,
  ...trPolish,
  'settings.title': 'AYARLAR',
  'settings.movement': 'Hareket Modu',
  'settings.movement.world': 'Dünya yönlü (twin-stick)',
  'settings.movement.nose': 'Burun yönlü (ileri = nişan)',
  'settings.autoaim': 'Otomatik Nişan',
  'settings.sound': 'Ses',
  'settings.language': 'Dil',
  'settings.on': 'AÇIK',
  'settings.off': 'KAPALI',
  'settings.fullscreen': 'Tam Ekran',
  'settings.back': '◀ GERİ',
  'settings.hint.keyboard': '↑/↓ seç    ←/→ veya Space değiştir    Esc geri',
  'settings.hint.gamepad': '↑/↓ seç    ←/→ veya Ⓐ değiştir    Ⓑ/Start geri',
  'settings.hint.touch': 'Değiştirmek için seçeneğe dokun',

  'fs.title': 'Tam ekran oynamak ister misin?',
  'rotate.title': 'Cihazını yan çevir — Atlas: Boss Rush yatay oynanır',
  'xbox.gamepadHint': 'Kumanda algılanmadı. Edge adres çubuğu menüsünden bu site için OYUN KUMANDASI kontrolünü seç, sonra kolda bir tuşa bas.',
  'fs.yes': 'EVET',
  'fs.no': 'HAYIR',

  'shop.title': 'YÜKSELTME',
  'shop.rerollBtn': 'ÇEVİR',
  'shop.continueBtn': 'DEVAM ▶',
  'shop.next': 'SIRADAKİ ARENA',
  'shop.nextWaves': 'ÖNCE {n} DALGA',
  'gem.yellow': 'TAŞ',
  'gem.red': 'ÇEKİRDEK',
  'shop.collectionTitle': 'KART KOLEKSİYONU',
  'shop.level': 'SV {n}',

  'statp.title': 'GEMİ DURUMU',
  'statp.damage': 'HASAR',
  'statp.firerate': 'ATIŞ HIZI',
  'statp.bullet': 'MERMİ HASARI',
  'statp.bulletrate': 'MERMİ ATIŞ HIZI',
  'statp.plasma': 'PLAZMA HASARI',
  'statp.plasmarate': 'PLAZMA ATIŞ HIZI',
  'statp.laser': 'LAZER HASARI',
  'statp.laserrate': 'LAZER ATIŞ HIZI',
  'statp.bomb': 'BOMBA HASARI',
  'statp.bombrate': 'BOMBA ATIŞ HIZI',
  'statp.critchance': 'KRİTİK ŞANSI',
  'statp.critdamage': 'KRİTİK HASARI',
  'statp.projspeed': 'MERMİ SÜRATİ',
  'statp.range': 'ATIŞ MENZİLİ',
  'statp.supershot': 'SUPERSHOT HSR',
  'statp.fan': 'SUPERSHOT YELP.',
  'statp.tier': 'NAMLU KADEMESİ',
  'statp.maxhp': 'AZAMİ CAN',
  'statp.shieldstart': 'BAŞL. ZIRH',
  'statp.rerolldisc': 'ÇEVİRME FİYATI',
  'statp.reduction': 'HASAR AZALTMA',
  'statp.aegis': 'AEGIS BAĞI',
  'statp.armorkill': 'ZIRH / BOSS',
  'statp.iframes': 'VURUŞ KORUMASI',
  'statp.speed': 'HAREKET HIZI',
  'statp.dashcd': 'DASH BEKLEMESİ',
  'statp.magnet': 'MIKNATIS',
  'statp.greed': 'TAŞ KAZANCI',
  'statp.discount': 'DÜKKÂN FİYATI',
  'statp.regen': 'ARENA TAMİRİ',
  'statp.lifesteal': 'CAN EMME',
  'statp.cargo': 'KARGO BÖLMESİ',
  'statp.energy': 'ENERJİ / İSABET',

  'wstat.rate': 'ATIŞ HIZI',
  'wstat.dps': 'DPS',
  'wstat.behavior': 'TÜR',

  'confirm.yes': 'ONAYLA',
  'confirm.no': 'VAZGEÇ',
  'confirm.deleteSave': 'Bu kayıt silinsin mi? Bu slottaki koleksiyon ve tüm ilerleme kaybolur.',

  'hud.portalOpen': 'PORTAL AÇILDI',
  'hud.wave': 'DALGA {n}/{m}',
  'hud.bossIncoming': 'BOSS GELİYOR',
  'hud.levelUp': 'SEVİYE ATLADIN — LV {n}',

  'title.continue': 'DEVAM ET',
  'title.settings': 'AYARLAR',
  'title.tag': 'sektör boss rush',
  'title.calibration': 'GAMEPAD TESTİ',
  'calib.title': 'GAMEPAD KALİBRASYONU — her şeyi oynat',
  'calib.exit': 'Ⓑ / Esc — geri',
  'calib.nopad': 'Gamepad algılanmadı — kolda bir tuşa bas',
  'calib.interpreted': 'OYUNUN OKUDUĞU',
  'title.slot': 'SLOT {n}',
  'title.slotEmpty': 'BOŞ — YENİ OYUN BAŞLAT',
  'title.deleteHint': '✕ / Ⓧ — seçili kaydı sil',
  'title.back': '◀ GERİ',
  'title.pickContinue': 'DEVAM ET — SLOT SEÇ',
  'title.seed': 'SEED: {v}',
  'title.seedRandom': 'RASTGELE',
  'title.seedPrompt': 'Seed (boş bırak = rastgele)',
  'title.overwrite': 'ÜZERİNE YAZ',
  'gameover.title': 'GEMİ YOK OLDU',
  'gameover.burnTitle': 'Tekrar uçmak için {n} kart daha yak',
  'gameover.extraHint': 'Fazladan yakılan her kart ZIRH onarır',
  'gameover.armorBonus': '+{n} ZIRH',
  'gameover.burned': 'YAKILDI',
  'gameover.weaponTag': 'SİLAH',
  'gameover.continueBtn': 'OYUNA DÖN ▶',
  'gameover.menuBtn': 'ANA MENÜ',
  'gameover.newRecord': '★ YENİ REKOR ★',
  'gameover.seed': 'Seed: {seed}',
  'gameover.totalRuns': 'DENEME #{n}',
  'gameover.hint.keyboard': '←/→ seç    Space yak / onayla',
  'gameover.hint.gamepad': '←/→ seç    Ⓐ yak / onayla',
  'gameover.hint.touch': 'Yakmak için karta dokun',

  'stats.timeAlive': 'Hayatta kalma süresi',
  'stats.bossKills': 'Kesilen boss',
  'stats.droneKills': 'Kesilen drone',
  'stats.gemsCollected': 'Toplanan taş',
  'stats.bulletsFired': 'Atılan mermi',
  'stats.damageDealt': 'Verilen hasar',
  'stats.arenasCleared': 'Geçilen arena',

  'weapon.autocannon': 'Otomatik Top',
  'weapon.smg': 'Hurda SMG',
  'weapon.heavy_cannon': 'Ağır Top',
  'weapon.plasma_orb': 'Plazma Küresi',
  'weapon.plasma_lance': 'Plazma Mızrağı',
  'weapon.needle_laser': 'İğne Lazer',
  'weapon.pulse_laser': 'Darbe Lazeri',
  'weapon.mortar': 'Havan',
  'weapon.rocket': 'Roketatar',
  'weapon.homing_missile': 'Güdümlü Füze',

  'card.damage.name': 'Ağır Mühimmat',
  'card.damage.desc': 'Tüm hasar +%4',
  'card.firerate.name': 'Hızlı Şarjör',
  'card.firerate.desc': 'TÜM silah grupları: atış hızı +%5',
  'card.catbullet.name': 'Balistik Lab.',
  'card.catbullet.desc': 'MERMİ silahları: hasar +%5',
  'card.catplasma.name': 'Plazma Armonisi',
  'card.catplasma.desc': 'PLAZMA silahları: hasar +%5',
  'card.catlaser.name': 'Optik Dizisi',
  'card.catlaser.desc': 'LAZER silahları: hasar +%5',
  'card.catbomb.name': 'Yıkım Kiti',
  'card.catbomb.desc': 'BOMBA silahları: hasar +%5',
  'card.ratebullet.name': 'Şerit Besleyici',
  'card.ratebullet.desc': 'MERMİ silahları: atış hızı +%5',
  'card.rateplasma.name': 'Bobin Döngüsü',
  'card.rateplasma.desc': 'PLAZMA silahları: atış hızı +%5',
  'card.ratelaser.name': 'Darbe Kapasitörü',
  'card.ratelaser.desc': 'LAZER silahları: atış hızı +%5',
  'card.ratebomb.name': 'Seri Dolumcu',
  'card.ratebomb.desc': 'BOMBA silahları: atış hızı +%5',
  'card.range.name': 'Uzun Namlu Bobini',
  'card.range.desc': 'Atış menzili +%8',
  'card.critchance.name': 'Hedef Analizörü',
  'card.critchance.desc': 'Kritik şansı +%3',
  'card.critdamage.name': 'Delici Şarj',
  'card.critdamage.desc': 'Kritik hasarı +%15',
  'card.projspeed.name': 'Hız Bobinleri',
  'card.projspeed.desc': 'Mermi sürati +%6',
  'card.dashcd.name': 'Dash Kapasitörü',
  'card.dashcd.desc': 'Dash beklemesi -%6',
  'card.greed.name': 'Hırs Devresi',
  'card.greed.desc': 'Sarı taş kazancı +%8',
  'card.supershot.name': 'Yükselteç',
  'card.supershot.desc': 'Supershot hasarı +%10',
  'card.focus.name': 'Işın Bölücü',
  'card.focus.desc': 'Supershot yelpazesi +1 mermi',
  'card.shieldstart.name': 'Faz Kalkanı',
  'card.shieldstart.desc': 'Her arenaya +1 zırh birimiyle başla',
  'card.iframes.name': 'Reaktif Zırh',
  'card.iframes.desc': 'Hasar sonrası dokunulmazlık +%15',
  'card.discount.name': 'Ticaret Ruhsatı',
  'card.discount.desc': 'Dükkân kart fiyatları -%4',
  'card.luckychip.name': 'Şans Çipi',
  'card.luckychip.desc': 'Yeniden çevirme fiyatı asla artmaz',
  'card.platingdeal.name': 'Zırh Anlaşması',
  'card.platingdeal.desc': 'Sarı zırh alımı her kopyada -%25',
  'card.rerolldiscount.name': 'Çevirme Kuponu',
  'card.rerolldiscount.desc': 'Çevirme fiyatı kademeli iner: -%10 / -%25 / -%50',
  'card.cargo.name': 'Kargo Bölmesi',
  'card.cargo.desc': '+1 silah envanter bölmesi açar',
  'card.glasscannon.name': 'Cam Top',
  'card.glasscannon.desc': 'Hasar +%10, ama dokunulmazlık süresi -%15',
  'card.glasscannon.up': 'Hasar +%10',
  'card.glasscannon.down': 'Dokunulmazlık -%15',
  'card.hairtrigger.name': 'Hassas Tetik',
  'card.hairtrigger.desc': 'Atış hızı +%10, ama menzil -%8',
  'card.hairtrigger.up': 'Atış hızı +%10',
  'card.hairtrigger.down': 'Menzil -%8',
  'card.heavyplating.name': 'Ağır Kaplama',
  'card.heavyplating.desc': 'Her arena başında +1 zırh, ama hız -%7',
  'card.heavyplating.up': 'Arena başı +1 zırh',
  'card.heavyplating.down': 'Hız -%7',
  'card.boosterrig.name': 'İtici Donanım',
  'card.boosterrig.desc': 'Hız +%10, ama hasar -%3',
  'card.boosterrig.up': 'Hız +%10',
  'card.boosterrig.down': 'Hasar -%3',
  'card.lootballast.name': 'Ganimet Yükü',
  'card.lootballast.desc': 'Taş geliri +%18, ama hız -%4',
  'card.lootballast.up': 'Taş geliri +%18',
  'card.lootballast.down': 'Hız -%4',
  'card.bulwark.name': 'Sönümleme Alanı',
  'card.bulwark.desc': 'Gövdeye gelen hasar -%4',
  'card.salvager.name': 'Hurda Toplayıcı',
  'card.salvager.desc': 'Her boss ölümünde +1 zırh birimi',
  'card.aegislink.name': 'Aegis Bağı',
  'card.aegislink.desc': 'Hasar bonusunun YARISI kadar hasar azaltma (en çok %25)',
  'card.apex.name': 'Zirve Protokolü',
  'card.apex.desc': 'Kritik şansı +%5 VE kritik hasarı +%25',
  'card.lifesteal.name': 'Can Emici',
  'card.lifesteal.desc': 'Verilen hasarın %2\'si can olarak döner',
  'card.regen.name': 'Nano Sürüsü',
  'card.regen.desc': 'Her arena başında 25 HP tamir',
  'card.speed.name': 'İyon Motoru',
  'card.speed.desc': 'Hareket hızı +%4',
  'card.magnet.name': 'Çekim Bobini',
  'card.magnet.desc': 'Taş toplama yarıçapı +%15',
  'card.energy.name': 'Enerji İletkeni',
  'card.energy.desc': 'İsabet başına supershot enerjisi +1',
  'card.heart.name': 'Gövde Hücresi',
  'card.heart.desc': '+25 azami can (dolu bir batarya hücresi)',
  'card.barrel.name': 'Namlu Kademesi',
  'card.barrel.desc': 'Kademe +1: burun → kanatlar → kanat+burun → tepe supershot topu',
  'card.rack.name': 'Silah Rafı',
  'card.rack.desc': '+1 silah soketi (max 3) — hepsi kendi dolumuyla birlikte ateşler',
  'card.ghostdash.name': 'Hayalet Dash',
  'card.ghostdash.desc': 'Dash dokunulmazlığı +0.25sn — mermilerin içinden geç',
  'card.superfan.name': 'Aşırı Yük',
  'card.superfan.desc': 'Supershot yelpazesi +2 mermi',
  'card.overcharge.name': 'Savaş Çekirdeği',
  'card.overcharge.desc': 'Tüm hasar +%12',
};
